import React from 'react';
import { useLocation } from 'react-router-dom';
import PaymentResult from './PaymentResult/index';
import { createDynamicPaymentProps } from 'utils/servicePaymentUtils';

const GenericPaymentFailure: React.FC = () => {
  const location = useLocation();
  
  console.log('[PAYMENT_DEBUG] GenericPaymentFailure - Component rendering');
  console.log('[PAYMENT_DEBUG] GenericPaymentFailure - Current pathname:', location.pathname);
  console.log('[PAYMENT_DEBUG] GenericPaymentFailure - Location state:', location.state);
  console.log('[PAYMENT_DEBUG] GenericPaymentFailure - URL search params:', location.search);
  
  const props = createDynamicPaymentProps(location.pathname, 'failure');
  
  console.log('[PAYMENT_DEBUG] GenericPaymentFailure - Generated props from createDynamicPaymentProps:', props);
  console.log('[PAYMENT_DEBUG] GenericPaymentFailure - Payment status:', props.paymentStatus);
  console.log('[PAYMENT_DEBUG] GenericPaymentFailure - Service name:', props.serviceName);
  console.log('[PAYMENT_DEBUG] GenericPaymentFailure - Provider name:', props.providerName);
  console.log('[PAYMENT_DEBUG] GenericPaymentFailure - Service identifier:', props.serviceIdentifier);
  
  return <PaymentResult {...props} />;
};

export default GenericPaymentFailure;